import "../../../../styles/productView.scss";

import {Localization} from "../../../common/util/localization.jsx";
import Modal from "../../../common/components/Modal.jsx";
import PropTypes from "prop-types";
import React from "react";
import ShoppingCart from "../../components/order/ShoppingCart.jsx";
import {scssVariables} from "../../../common/util/config.jsx";

// Component for displaying the last order which has passed customer deadline but not yet invoiced
// Shoppingcart can be viewed but not altered
class LastOrderModal extends React.PureComponent {
    constructor(props){
        super(props);

        this.calculateShoppingCartHeight = this.calculateShoppingCartHeight.bind(this);
    }

    calculateShoppingCartHeight() {
        const {
            deviceType,
            height,
        } = this.props;
        let productDisplayHeight = height;
        
        //page padding
        productDisplayHeight -= parseInt(scssVariables[`${deviceType}ContentPadding`])*2;
        //product display margin
        productDisplayHeight -= parseInt(scssVariables.cardMargin)*2;

        productDisplayHeight -= 50;

        return productDisplayHeight;
    }

    render(){
        const {
            localization,
            activeOrder,
            deviceType,
            onCloseModal,
            setModal,
            width,
            orderFeeLimits,
            orderVolumeDiscounts,
        } = this.props;

        const shoppingCartHeight = this.calculateShoppingCartHeight();

        return (
            <Modal onCloseModal={onCloseModal} width={width}>
                <ShoppingCart
                    localization={localization}
                    height={shoppingCartHeight}
                    deviceType={deviceType}
                    width={width}
                    activeOrder={activeOrder}
                    setModal={setModal}
                    orderFeeLimits={orderFeeLimits}
                    orderVolumeDiscounts={orderVolumeDiscounts}
                    lastOrder={true}
                />
            </Modal>
        );
    }
}

LastOrderModal.propTypes = {
    localization: Localization.propTypes.isRequired,
    activeOrder: PropTypes.object.isRequired,
    deviceType: PropTypes.string.isRequired,
    width: PropTypes.number,
    setModal: PropTypes.func.isRequired,
    orderFeeLimits: PropTypes.array.isRequired,
    orderVolumeDiscounts: PropTypes.array.isRequired,
    onCloseModal: PropTypes.func.isRequired,
    height: PropTypes.number.isRequired,
};

export default LastOrderModal;